import { jsx as i } from "react/jsx-runtime";
import { useTooltip as p } from "../hooks/useTooltip.js";
import { TooltipContext as m } from "../hooks/useTooltipContext.js";
const n = ({
  children: o,
  position: r,
  disabled: t = !1
}) => {
  const e = p({ position: r, disabled: t });
  return /* @__PURE__ */ i(m.Provider, { value: e, children: o });
};
export {
  n as Provider
};
//# sourceMappingURL=Provider.js.map
